import React, { useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { Collapse, Divider, Icon } from '@material-ui/core';
import {
  ROUTE_ADMIN_MODELS,
  ROUTE_ADMIN_BRANDS,
  ROUTE_ADMIN_CAMPAIGN,
  ROUTE_ADMIN_FILE_MANAGEMENT,
  ROUTE_ADMIN_WORKSHOPS,
  ROUTE_CONTRACT_DATA,
  ROUTE_ENTRY_CHANNEL,
  ROUTE_EXCEPTIONS,
  ROUTE_EXTERNAL_USERS,
  ROUTE_INTERACTION,
  ROUTE_MAIL_MAPPERS,
  ROUTE_STATES,
  ROUTE_SUBSTATES,
  ROUTE_TAXONOMIES,
  ROUTE_TEMPLATES,
  ROUTE_USERS,
} from '../routes/routesConstants';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { isUserInRole, isUserInRoles } from '../../commonFunctions/commonFunctions';
import { ADMIN_BOSCH, ADMIN } from '../../Constantes/userRoles';
import { useSelector } from 'react-redux';
import { selectUserRoles } from '../../redux/authentication/selectors';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 0,
    backgroundColor: '#3B5158',
    color: '#FFF',
  },
  list: {
    paddingTop: '5px',
    paddingBottom: 0,
  },
  listItem: {
    fontSize: '.9em',
  },
  listItemNested: {
    fontSize: '.8em',
    marginLeft: '10px',
  },
  divider: {
    backgroundColor: '#fff',
    opacity: '.5',
  },
  button: {
    '&:hover': {
      opacity: '.5',
    },
  },
}));

const linkData = [
  {
    url: ROUTE_ENTRY_CHANNEL,
    text: 'Canais de entrada',
    allowedRoles: [ADMIN],
  },
  {
    url: ROUTE_CONTRACT_DATA,
    text: 'Contratos',
    allowedRoles: [ADMIN_BOSCH],
  },
  { url: ROUTE_MAIL_MAPPERS, text: 'E-mails autorizados', allowedRoles: [ADMIN] },
  {
    url: ROUTE_STATES,
    text: 'Status',
    allowedRoles: [ADMIN],
  },
  // {
  //   url: ROUTE_SUBSTATES,
  //   text: 'Sub-estados',
  //   allowedRoles: [ADMIN],
  // },
  {
    url: ROUTE_EXCEPTIONS,
    text: 'Exceções',
    allowedRoles: [ADMIN_BOSCH],
  },
  {
    url: ROUTE_INTERACTION,
    text: 'Interações',
    allowedRoles: [ADMIN_BOSCH],
  },
  {
    url: ROUTE_TEMPLATES,
    text: 'Templates',
    allowedRoles: [ADMIN],
  },
  {
    url: ROUTE_ADMIN_WORKSHOPS,
    text: 'Talleres',
    allowedRoles: [ADMIN_BOSCH],
  },
  {
    url: ROUTE_TAXONOMIES,
    text: 'Taxonomias',
    allowedRoles: [ADMIN],
  },
  {
    url: ROUTE_ADMIN_BRANDS,
    text: 'Montadoras',
    allowedRoles: [ADMIN],
  },
  {
    url: ROUTE_ADMIN_MODELS,
    text: 'Modelos',
    allowedRoles: [ADMIN],
  },
  {
    url: ROUTE_USERS,
    text: 'Usuários',
    allowedRoles: [ADMIN_BOSCH],
  },
  {
    url: ROUTE_EXTERNAL_USERS,
    text: 'Usuários externos',
    allowedRoles: [ADMIN_BOSCH],
  },
];

function AdminMenu(props) {
  const { anchor, open, handleClose, handleMenuClick } = props;
  const [openNestedMenu, setOpenNestedMenu] = useState(false);
  const classes = useStyles();
  const userRoles = useSelector(selectUserRoles);

  return (
    <Popper id="admin-popper" open={open} anchorEl={anchor.current} transition disablePortal placement={'bottom-start'}>
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: 'left top', left: '5px' }}>
          <Paper elevation={0} classes={{ root: classes.paper }}>
            <ClickAwayListener onClickAway={() => handleClose(false)}>
              <MenuList autoFocusItem={open} id="menu-list-grow" classes={{ root: classes.list }}>
                {/* <MenuItem key={"Campañas"}  onClick = {()=>{handleMenuClick(ROUTE_ADMIN_CAMPAIGN); handleClose(false)}} ListItemClasses = {{button: classes.button}} target="_blank" classes = {{root: classes.listItem}}>{"Campanhas"}</MenuItem> */}
                {isUserInRole(ADMIN, userRoles) && (
                  <>
                    <MenuItem button ListItemClasses={{ button: classes.button }} target="_blank" classes={{ root: classes.listItem }} onClick={() => !setOpenNestedMenu(!openNestedMenu)}>
                      <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <span>{'Edição de dados mestres'}</span>
                        {openNestedMenu ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                      </span>
                    </MenuItem>
                    <Collapse in={openNestedMenu} timeout="auto" unmountOnExit>
                      <MenuList>
                        {linkData.map((value, index, array) =>
                          isUserInRoles(value.allowedRoles, userRoles) && (
                            [
                              <MenuItem
                                key={value.text}
                                ListItemClasses={{ button: classes.button }}
                                target="_blank"
                                classes={{ root: classes.listItemNested }}
                                onClick={() => {
                                  handleMenuClick(value.url);
                                  handleClose(false);
                                }}
                              >
                                {value.text}
                              </MenuItem>,
                              index < array.length - 1 && <Divider key={'divider-' + index} classes={{ root: classes.divider }} component="li" />,
                            ]
                          )
                        )}
                      </MenuList>
                    </Collapse>
                  </>
                )}
                {isUserInRole(ADMIN, userRoles) && (
                  <MenuItem
                    key={'Importación CSV'}
                    onClick={() => {
                      handleMenuClick(ROUTE_ADMIN_FILE_MANAGEMENT);
                      handleClose(false);
                    }}
                    ListItemClasses={{ button: classes.button }}
                    target="_blank"
                    classes={{ root: classes.listItem }}
                  >
                    {'Importar CSV'}
                  </MenuItem>
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

export { AdminMenu };
